module.exports = __webpack_public_path__ + "media/images/lp/lp20-2-a5e40dd9c059da683ff81fb810b61bb1.webp";